import React from 'react';
import {connect} from "react-redux";
import CustomPaper from '../../shared/utils/CustomPaper';
import AuthService from '../../../services/AuthService';
import TextField from "material-ui/TextField";
import StarRatingComponent from "react-star-rating-component";


class BibliothequeDesCompetencesSalarie extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showSetRating: false,
            showEditRating: false,
            filter: '',
            salariesHavingCompetenceRated: [],
            selectedCompetence: null
        };
        this.Auth = new AuthService();
        this.fetchBibliotheque = this.fetchBibliotheque.bind(this);
        this.fetchCompetence = this.fetchCompetence.bind(this);
        this.rateCompetence = this.rateCompetence.bind(this);
    }

    componentDidMount() {
        this.fetchBibliotheque();
    }

    fetchBibliotheque() {
        this.Auth.fetch('/societe/competences/all')
            .then(x => this.setState({data: x.data.payload}));
    }

    fetchCompetence(competence) {
        this.setState({selectedCompetence: competence, showSetRating: false},
            () =>
                this.Auth.fetch('/societe/competence/relative', {method: 'POST', data: {competence: competence}})
                    .then(x => this.setState({
                        salariesHavingCompetenceRated: x.data.payload.salariesHavingCompetenceRated
                    }))
        );
    }

    rateCompetence(score) {
        this.Auth.fetch('/societe/competence/rating',
            {
                method: 'POST',
                data: {
                    competence: this.state.selectedCompetence,
                    niveau: score
                }
            })
            .then(x => {
                    this.fetchCompetence(this.state.selectedCompetence);
                    this.setState({showSetRating: true, showEditRating: false})
                }
            );
    }

    render() {
        const filteredCompetenceList = this.state.data
            .filter(c => c.competence.toUpperCase().indexOf(this.state.filter.toUpperCase()) > -1);
        const rating = this.state.salariesHavingCompetenceRated.filter(s => s.id = this.props.id_salarie);
        return (
            <div className="row">
                <div
                    className={this.state.selectedCompetence ? 'col-7' : 'col'}>
                    <CustomPaper title={"Bibliothèque des compétences"}>
                        <TextField
                            value={this.state.filter}
                            onChange={(x, y, z) => this.setState({filter: y})}
                            name='filter'
                            fullWidth={true}
                            type="text"
                            floatingLabelText="Filtrer par compétence"
                        />
                        <span className="badge badge-primary">{filteredCompetenceList.length} Compétances</span>
                        <ul className="scrollableUL">
                            {
                                filteredCompetenceList.map(c =>
                                    <li key={c.competence}>{c.competence}
                                        <a
                                            style={{color: "blue", marginLeft: 10, cursor: "pointer"}}
                                            className="no-print"
                                            onClick={() => this.fetchCompetence(c.competence)}
                                        >
                                            Détailler
                                        </a>
                                    </li>
                                )
                            }
                        </ul>
                    </CustomPaper>
                </div>
                {
                    this.state.selectedCompetence
                    &&
                    <div className="col-5" style={{position: 'fixed', right: 0}}>

                        <CustomPaper title={"Détails de la compétence"}>
                            <div className="row" style={{marginBottom: 25}}>
                                <div className="col-10">{this.state.selectedCompetence}</div>
                                <a
                                    style={{color: 'red'}}
                                    onClick={() => this.setState({selectedCompetence: null})}
                                    className="col-2"
                                >Fermer
                                </a>
                            </div>

                            <label className="text-primary">Votre niveau de maitrise de cette compétence :</label><br/>
                            {
                                rating.length > 0
                                    ? <div>
                                        {
                                            !this.state.showEditRating
                                                ?
                                                <div>
                                                    <StarRatingComponent
                                                        name='rating-show'
                                                        editing={false}
                                                        value={Number(rating[0].niveau)}
                                                    /><br/>
                                                    <button
                                                        className="btn btn-sm btn-warning"
                                                        onClick={() => this.setState({showEditRating: true})}
                                                    >
                                                        Modifier
                                                    </button>
                                                </div>
                                                :
                                                <StarRatingComponent
                                                    name='rating-edit'
                                                    onStarClick={(nextValue) => this.rateCompetence(nextValue)}
                                                />
                                        }
                                        <br/>
                                    </div>
                                    :
                                    <div>
                                        {
                                            !this.state.showSetRating
                                            &&
                                            <button
                                                className="btn btn-sm btn-info"
                                                onClick={() => this.setState({showSetRating: true})}
                                            >
                                                Indiquer Votre niveau de maitrise
                                            </button>
                                        }

                                        {
                                            this.state.showSetRating
                                            &&
                                            <StarRatingComponent
                                                name='rating-set'
                                                onStarClick={(nextValue) => this.rateCompetence(nextValue)}
                                            />
                                        }
                                    </div>

                            }

                        </CustomPaper>

                    </div>
                }
            </div>

        );
    }
}

function mapStateToProps(store) {
    return {
        id_salarie: store.salarie.infos.id
    }
}

export default connect(mapStateToProps)(BibliothequeDesCompetencesSalarie);


// WEBPACK FOOTER //
// ./src/components/salarie/bodies/BibliothequeDesCompetencesSalarie.js